var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-handle",on:{"mousedown":_vm.mouseDown}})
}
var staticRenderFns = []

export { render, staticRenderFns }